// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__aTttL","tabButton":"styles_tabButton__wvSLf","closed":"styles_closed__HbSmL","morePopover":"styles_morePopover__ht7nX","moreMenu":"styles_moreMenu__Cjzgj"};